// tslint:disable
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ConfigProvider } from 'providers/config/config';
import { AuthService } from './login/auth.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { GenProvider } from '../providers/gen/gen';

@Component({
  selector: 'body',
  styleUrls: ['app.component.scss'],
  templateUrl: './app.component.html',
  /*
  template: '<router-outlet></router-outlet>'
*/

})
export class AppComponent implements OnInit {
  title = 'MEGATEC';
  public toggleBarIcon: boolean = true;
  usuario: any;
  mostrarMenu: boolean = false;
  message;


  constructor(
    private router: Router,
    public auth: AngularFireAuth,
    private authService: AuthService,
    public configProvider: ConfigProvider,
    private genProvider: GenProvider)
     {

  }
  ngOnInit() {
    let user = {
      email: 'login@login.com',
      password: '123456'
    };

    this.auth.auth
      .signInWithEmailAndPassword(user.email, user.password)
      .then(() => {
        //    console.log('Autenticado');
//        this.msgService.getPermission()
        this.onStart();
      })
      .catch((error: any) => {
        alert('Erro na autenticação ' + error.code);
      });
  //    setTimeout(() => {
//
   //   }, 1000)


    /*    this.router.events.subscribe((evt) => {
          if (!(evt instanceof NavigationEnd)) {
            return;
          }
          window.scrollTo(0, 0)
        });



service cloud.firestore {
  match /databases/{database}/documents {
    match /{document=**} {
      allow read, write: if true;
    }
  }
}
        */
    this.authService.mostrarMenuEmitter.subscribe(
      (mostrar) => {
        this.mostrarMenu = mostrar;
        this.usuario = JSON.parse(this.configProvider.getConfigData());

      }
    );
  }
  onStart(){
    this.genProvider.onGetAll('login','nome')
    .subscribe(data => {
      let dados = JSON.parse(JSON.stringify(data))
      if (dados.length == 0){
        let login ={
          grupo: "Administrador",
          key_login: "0",
          login: "icstech",
          nivel: "99",
          nome: "ICSTECH",
          path: "icstech",
          senha: "admin",
          status: "Ativo"
          }
          this.genProvider.onSave('login', login) // atualiza o registro com a mesma chave
      }
    });

  }
  toggle(): void {
    let self = this;
    setTimeout(() => {
      self.toggleBarIcon = !self.toggleBarIcon;

    }, 500)
  }
}


/*
auqivos pdf
https://github.com/VadimDez/ng2-pdf-viewer -> visualizador de PDF




https://github.com/MrRio/jsPDF --> relatorio em PDF
npm install ng2-pdf-viewer --save-dev

https://rawgit.com/MrRio/jsPDF/master/ --> exemplo

npm install jspdf --save

npm install @types/jspdf --save-dev

 Fabric.js ou Raphal.js   -> gerar graficos


*/



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/app.component.ts